import { ListItem, ListItemText } from "@mui/material";
import { useRouter } from "next/router";
import theme from "#next/theme";
import {
  LeftSideNav as LeftSideNavAction,
  ProjectEditor,
  trackAction,
} from "#next/utils/trackUserActions";
import { Link } from "#next/components/reusable/Link";

const NavLocationMap = {
  explorer: "/explorer",
  projectEditor: "/project-editor",
  mySettings: "/my-settings",
  pyrraAdmin: "/pyrra-admin-controls",
  catalog: "/catalog",
  userSearch: "/user-search",
} as const;

export const useCheckIfCurrentRoute = (
  location: keyof typeof NavLocationMap,
  projectId?: string,
  username?: string,
  platform?: string,
) => {
  const router = useRouter();
  const matchesLocation = router.pathname === NavLocationMap[location];
  // This seems overly complicated.
  return (
    (matchesLocation && projectId && router.query.projectId === projectId) ||
    (matchesLocation &&
      username &&
      router.query.username === username &&
      platform &&
      router.query.platform === platform)
  );
};

export const highlightColor = theme.palette.amber.main;

export const NavigationLink = ({
  location,
  name,
  actionName,
  onSelect,
}: {
  location: keyof typeof NavLocationMap;
  name: string;
  actionName: LeftSideNavAction | ProjectEditor;
  onSelect?: () => void;
}) => {
  const isCurrent = useCheckIfCurrentRoute(location);

  const linkStyle = {
    "&:hover": {
      color: isCurrent ? undefined : highlightColor,
    },
  };

  return (
    <ListItem
      sx={{
        py: 0,
        backgroundColor: isCurrent ? highlightColor : undefined,
      }}
    >
      <ListItemText>
        <Link
          sx={linkStyle}
          onClick={() => {
            trackAction(actionName);
            onSelect?.();
          }}
          href={NavLocationMap[location]}
        >
          {name}
        </Link>
      </ListItemText>
    </ListItem>
  );
};
